import { render, staticRenderFns } from "./Agroturismos.vue?vue&type=template&id=2d6d6896"
import script from "./Agroturismos.vue?vue&type=script&lang=js"
export * from "./Agroturismos.vue?vue&type=script&lang=js"
import style0 from "./Agroturismos.vue?vue&type=style&index=0&id=2d6d6896&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports